module.exports = __webpack_public_path__ + "static/media/accepter.948f7bdf.png";